/* @flow */
import App from "./App";
import BrowserHistory from "react-history/BrowserHistory";
import React from "react";
import { Provider as Redux, connect } from "react-redux";
import { StaticRouter } from "react-router";
import { setLocation } from "../../common/app/actions";

import Alert from "react-s-alert";

type RouterProps = {
  dispatch: () => void,
  pathname: ?string
};

const confirm = dispatch => {
  return new Promise((resolve, reject) => {
    dispatch({ type: "TRANSITION_BLOCK", payload: { resolve, reject } });
  });
};

// TODO: Use ControlledRouter once it will be released.
const Router = ({ dispatch, pathname }: RouterProps) => (
  <BrowserHistory
    getUserConfirmation={(message, callback) => {
      confirm(dispatch)
        .then(() => {
          callback(true);
        })
        .catch(() => {
          callback(false);
        });
    }}
  >
    {({ history, action, location }) => {
      if (location.pathname !== pathname) {
        setImmediate(() => {
          dispatch(setLocation(location));
        });
      }
      return (
        <StaticRouter
          action={action}
          blockTransitions={history.block}
          key={pathname} // github.com/yahoo/react-intl/issues/234#issuecomment-163366518
          location={location}
          onPush={history.push}
          onReplace={history.replace}
        >
          <App />
        </StaticRouter>
      );
    }}
  </BrowserHistory>
);

const ConnectedRouter = connect(state => ({
  pathname: state.app.location && state.app.location.pathname
}))(Router);

type RootProps = {
  store: Object
};

// We needs such Root for vanilla hot reloading.
const Root = ({ store }: RootProps) => (
  <div>
    <Redux store={store}>
      <ConnectedRouter />
    </Redux>
    <Alert stack={{ limit: 3 }} />
  </div>
);

export default Root;



/** WEBPACK FOOTER **
 ** ./src/browser/app/Root.js
 **/